export default function ProWorldScreen({world,progress,onSelectLesson,onBack}){
  const done=world.lessons.filter((_,i)=>progress[`${world.id}-${i}`]).length;
  return(
    <div style={{fontFamily:"Nunito",minHeight:"100vh",background:"#0f172a",paddingBottom:100}}>
      <div style={{background:`linear-gradient(135deg,${world.color},${world.dark})`,padding:"18px 16px 24px",position:"relative",overflow:"hidden"}}>
        <div style={{position:"absolute",top:-20,right:-10,fontSize:100,opacity:0.1}}>{world.emoji}</div>
        <button onClick={onBack} className="btn-bounce"
          style={{background:"#ffffff25",border:"2px solid #ffffff44",borderRadius:12,
            padding:"6px 14px",fontSize:13,fontWeight:800,color:"#fff",cursor:"pointer",marginBottom:12,display:"block"}}>
          ← Dashboard
        </button>
        <div style={{display:"flex",gap:14,alignItems:"center"}}>
          <div style={{fontSize:48,lineHeight:1}}>{world.emoji}</div>
          <div>
            <div style={{fontSize:11,color:"#ffffff99",fontWeight:800,textTransform:"uppercase",letterSpacing:2,marginBottom:2}}>{world.tag}</div>
            <div style={{fontSize:22,fontWeight:900,color:"#fff",fontFamily:"Fredoka One"}}>{world.label}</div>
            <div style={{fontSize:13,color:"#ffffffcc",fontWeight:700,marginTop:2}}>✅ {done}/{world.lessons.length} lessons complete</div>
          </div>
        </div>
      </div>
      <div style={{padding:"16px",display:"flex",flexDirection:"column",gap:10}}>
        {world.lessons.map((lesson,i)=>{
          const isDone=progress[`${world.id}-${i}`];
          return(
            <button key={i} onClick={()=>onSelectLesson(i)} className="btn-bounce"
              style={{background:isDone?"#1e293b":"#1e293b",
                border:`2px solid ${isDone?world.color:"#334155"}`,
                borderRadius:16,padding:"14px 16px",cursor:"pointer",textAlign:"left",
                boxShadow:isDone?`0 4px 14px ${world.color}33`:"none"}}>
              <div style={{display:"flex",alignItems:"flex-start",gap:12}}>
                <div style={{width:32,height:32,borderRadius:"50%",flexShrink:0,
                  background:isDone?`linear-gradient(135deg,${world.color},${world.dark})`:"#334155",
                  display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:900,color:"#fff"}}>
                  {isDone?"✓":i+1}
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:900,color:"#f1f5f9",marginBottom:4}}>{lesson.title}</div>
                  <div style={{fontSize:11,color:isDone?world.color:"#64748b",fontWeight:700}}>{lesson.key.slice(0,60)}…</div>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
